<pk-broker-loader [show]="loading"></pk-broker-loader>
@if (!loading) {
	<form [formGroup]="formGroup">
		<div class="row">
			<div class="col-md-2">
				<div class="form-element-container">
					<pk-broker-form-dropdown formControlName="units" [options]="bidMeasureUnits" label="Units"></pk-broker-form-dropdown>
				</div>
			</div>
			<div class="col-md-2">
				<div class="form-element-container">
					<label class="title required font-weight-bold" for="isOnHold">On Hold</label>
					<pk-broker-form-dropdown [isRequired]="true" formControlName="isOnHold" [options]="[true, false]" [textMap]="yesNoTextMap">
					</pk-broker-form-dropdown>
				</div>
			</div>
		</div>
		<h3>Bid Rate</h3>
		<div class="row">
			<div class="col-md-2">
				<div class="form-element-container">
					<label class="title" for="margin">Broker Margin</label>
					<input type="number" class="form-control" [value]="brokerMargin" readonly />
					<small class="text-muted">{{ form.units?.value?.text }}</small>
				</div>
				<span class="text-danger">*Margin includes current contract's total broker/brother/parent margin</span>
			</div>
			<span class="big-number">+</span>
			<div class="col-md-2">
				<div class="form-element-container">
					<label class="title required" for="bidAmount">Bid Buffer Margin</label>
					<input type="number" step="0.00001" class="form-control required" formControlName="bufferMargin" />
					<small class="text-muted">{{ form.units?.value?.text }}</small>
				</div>
				<span>Old: {{ originalBufferMargin }} {{ form.units?.value?.text }}</span> <br />
				<span [ngClass]="{ 'green-text': bufferMarginChange > 0, 'red-text': bufferMarginChange < 0 }"
					>Change: {{ bufferMarginChange > 0 ? '+' : '' }}{{ bufferMarginChange }} {{ form.units?.value?.text }}</span
				>
				<p class="text-danger mt-2">*This is the buffer margin that is associated with the submitted bid rate.</p>
			</div>
			<span class="big-number">+</span>
			<div class="col-md-2">
				<div class="form-element-container">
					<label class="title required" for="bidAmount">Bid Packing Margin</label>
					<input type="number" step="0.00001" class="form-control required" formControlName="packingMargin" />
					<small class="text-muted">{{ form.units?.value?.text }}</small>
				</div>
				<span>Old: {{ originalPackingMargin }} {{ form.units?.value?.text }}</span> <br />
				<span [ngClass]="{ 'green-text': packingMarginChange > 0, 'red-text': packingMarginChange < 0 }"
					>Change: {{ packingMarginChange > 0 ? '+' : '' }}{{ packingMarginChange }} {{ form.units?.value?.text }}</span
				>
				<p class="text-danger mt-2">*This is the packing margin that is associated with the submitted bid rate.</p>
			</div>
			<span class="big-number">+</span>
			<div class="col-md-2">
				<div class="form-element-container">
					<label class="title required" for="bidAmount">Supplier Base Bid Rate</label>
					<input type="number" step="0.00001" class="form-control required" formControlName="bidAmount" />
					<small class="text-muted">{{ form.units?.value?.text }}</small>
				</div>
				<span>Old: {{ originalSupplierBaseBidRate }} {{ form.units?.value?.text }}</span> <br />
				<span [ngClass]="{ 'green-text': supplierBaseBidRateChange > 0, 'red-text': supplierBaseBidRateChange < 0 }"
					>Change: {{ supplierBaseBidRateChange > 0 ? '+' : '' }}{{ supplierBaseBidRateChange }} {{ form.units?.value?.text }}</span
				>
				<p class="text-danger mt-2">*This is the supplier's base bid rate without any buffer, packing, or broker margins</p>
			</div>
			<span class="big-number">=</span>
			<div class="col-md-2">
				<div class="form-element-container">
					<label class="title" for="margin">Final Bid Rate</label>
					<input type="number" class="form-control" [value]="totalBidRate" readonly />
					<small class="text-muted">{{ form.units?.value?.text }}</small>
				</div>
				<span>Old: {{ originalFinalBidRate }} {{ form.units?.value?.text }}</span> <br />
				<span [ngClass]="{ 'green-text': finalBidRateChange > 0, 'red-text': finalBidRateChange < 0 }"
					>Change: {{ finalBidRateChange > 0 ? '+' : '' }}{{ finalBidRateChange }} {{ form.units?.value?.text }}</span
				>
				<p class="text-danger mt-2">
					*Final bid rate includes supplier base bid rate and all margins. This is the rate that will be shown when quoting with same
					broker/brother/parent margin.
				</p>
			</div>
		</div>
		<h3>Pricing Components</h3>
		<div class="row">
			<ng-container formArrayName="pricingComponents" *ngFor="let component of product.pricingComponents; let i = index">
				<div class="col-md-3 mb-3" [formGroupName]="i">
					<div class="card">
						<div class="card-body">
							<h3 class="card-title">{{ component.name }}</h3>
							<div class="input-group">
								<input class="form-control" type="number" step="0.00001" formControlName="amount" />
								<div class="input-group-append">
									<span class="input-group-text">{{ form.units.value?.text }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			@if (!product.pricingComponents.length) {
				<div class="col-md-12">
					<div class="alert alert-warning">There are no pricing components for this product.</div>
				</div>
			}
		</div>
	</form>
}
